import { UAParser } from 'ua-parser-js';
import { getUserAgent } from '../config/helpers';

export const isMacOs = () => {
  const userAgent = getUserAgent();
  if (!userAgent) {
    return false;
  }
  const parser = new UAParser(userAgent);
  const result = parser.getResult();
  return result?.os?.name === 'Mac OS';
};
